module.exports = __webpack_public_path__ + "img/lsgs.31a114b5.png";